/**
 * Обертка для работы с ajax-запросами
 *
 * Варианты использования для всех функций работы с ajax идентичны:
 *
 * Fotobook.ajax.request('controller/action', {data:{...}});
 * Fotobook.ajax.request('controller/action');
 *
 * Обработку колбеков производить через промисы
 * Fotobook.ajax.request('controller/action', {
 *      data: {
 *          key: value
 *      }).then(function(){
 *          //success callback
 *      }).catch(function(){
 *          //error callback
 *      });
 *
 */
'use strict';

(function () {
    const baseURL = '/ajax';

    const isAbsoluteURL = (url) => /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
    const combineURLs = (base, relativeURL) => (relativeURL ? base.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL);

    // Добавление префикса аналогично тому, как это делается в axios
    const normalizeUrl = (url) => {
        // Support baseURL config
        if (baseURL && !isAbsoluteURL(url)) {
            return combineURLs(baseURL, url);
        }
        return url;
    };

    /**
     * @namespace Fotobook.ajax
     * @deprecated - use axios instead
     */
    const self = Fotobook.ajax = {

        SUCCESS: 0,
        WARNING: 1,
        ERROR: 2,

        EVENT_BEFORE_DONE: 'ajaxBeforeDone',
        /**
         * Анализируем входные параметры для ajax запроса
         * и формируем корректный объект options
         *
         * @param url
         * @param options
         * @return {Object}
         */
        handleOptions(url, options = {}) {
            if (options.data instanceof FormData) {
                options.contentType = false;
                options.processData = false;
            }
            if (String(options.contentType).indexOf('application/json') === 0) {
                options.data = JSON.stringify(options.data);
                options.processData = false;
            }

            return $.extend({
                url: normalizeUrl(url),
                headers: {
                    FbOnlineEditor: Number(Fotobook.onlineEditorActive()),
                },
                cache: false,
                type: 'GET',
                data: {},
                dataType: 'json',
                timeout: 60 * 1000, // 1 минута
                longQueryTimeout: 1000,
                longQueryText: t('photobook-js-pleaseWait'),
                queue: true,
            }, options);
        },
        /**
         * Обертка jQuery.ajax
         * Предпочтительнее использовать функции Fotobook.ajax.get или Fotobook.ajax.post
         *
         * @param {string} url
         * @param {Object} options
         * @return Promise
         */
        request(url, options = {}) {
            return new Promise((resolve, reject) => {
                options = this.handleOptions(url, options);

                if (options.queue) {
                    const $html = $("html");
                    if (!$html.hasClass("ajax-queue")) {
                        $html.addClass("ajax-queue");
                        $(document).triggerHandler(Fotobook.events.AJAX_QUEUE_STARTED);
                    }
                }

                (options.queue ? $.ajaxQueue(options) : $.ajax(options)).done((response, status, xhr) => {
                    let result;

                    if (this.handleRedirect(xhr)) {
                        return;
                    }

                    const eventBeforeDone = $.Event(this.EVENT_BEFORE_DONE);
                    $(document).triggerHandler(eventBeforeDone, [response, status, xhr]);

                    if (!eventBeforeDone.isDefaultPrevented()) {
                        result = this.handleAjaxDone.call(this, response, status, xhr);
                    } else {
                        result = eventBeforeDone.result;
                    }
                    if (!result || result.error || result.warning) {
                        reject(response, status, xhr);
                    } else {
                        resolve(response, status, xhr);
                    }
                }).fail((xhr, status, text) => {
                    if (this.handleRedirect(xhr)) {
                        return;
                    }
                    this.handleAjaxFail(xhr, status, text);
                    reject(xhr, status, text);
                }).always(
                    this.handleAjaxAlways
                );
            });
        },
        /**
         * Обертка Fotobook.ajax.request с явным указанием метода отправки
         * в виде GET-запроса.
         *
         * @param {string} url Optionally specify the url as the first argument
         * @param {Object} options {@link jQuery#ajax}
         * @return Promise
         */
        get(url, options = {}) {
            options = $.extend({
                type: 'get',
            }, options);
            return self.request(url, options);
        },
        /**
         * Обертка Fotobook.ajax.request с явным указанием метода отправки
         * в виде POST-запроса.
         *
         * @param {string} url Optionally specify the url as the first argument
         * @param {Object} options {@link jQuery#ajax}
         * @return Promise
         */
        post(url, options = {}) {
            options = $.extend({
                type: 'post',
            }, options);
            return self.request(url, options);
        },
        /**
         * Обертка Fotobook.ajax.get для получение данных в формате JSON
         *
         * @param {string} url Optionally specify the url as the first argument
         * @param {Object} options {@link jQuery#ajax}
         * @return Promise
         */
        getJSON(url, options = {}) {
            options = $.extend({
                dataType: 'json',
            }, options);
            return self.get(url, options);
        },
        postJSON(url, options) {
            options = $.extend({
                dataType: 'json',
            }, options || {});
            return self.post(url, options);
        },
        /**
         * Обертка Fotobook.ajax.get для получение данных в формате HTML
         *
         * @param {string} url Optionally specify the url as the first argument
         * @param {Object} options {@link jQuery#ajax}
         * @return Promise
         */
        getHTML(url, options = {}) {
            options = $.extend({
                dataType: 'html',
            }, options);
            return self.get(url, options);
        },
        postHTML(url, options = {}) {
            options = $.extend({
                dataType: 'html',
            }, options);
            return self.post(url, options);
        },
        /**
         * Общая обработка положительного результата выполнения запроса
         *
         * @param {type} response
         * @param {type} status
         * @param {type} jqXHR
         * @returns {undefined}
         */
        handleAjaxDone(response, status, jqXHR) {
            const result = {
                warning: false,
                error: false,
            };

            if (response && response.status !== undefined) {
                if (response.status === self.ERROR) {
                    result.error = true;
                } else if (response.status === self.WARNING) {
                    result.warning = true;
                }
            }
            $(document).triggerHandler(Fotobook.events.AJAX_DONE, [result, response, jqXHR]);
            return result;
        },
        /*
         * Общая обработка неудачных запросов
         *
         * @param {type} jhr
         * @param {type} status
         * @param {type} text
         * @returns {undefined}
         */
        handleAjaxFail(jhr, status, text) {
            // Затыкаем показ ошибки - такое происходит в случае прерывания аякс запроса перезагрузкой страницы (может быть, есть ещё причины?)
            if ((jhr.readyState || jhr.status) && ([301, 302, 200].indexOf(jhr.status) === -1)) {
                Fotobook.notification.showError(`${jhr.statusText} ${jhr.status}`);
            }
        },
        /**
         * Обработка для всех запросов
         *
         * @param {type} response
         * @param {type} status
         * @param {type} jhr
         * @returns {undefined}
         */
        handleAjaxAlways(response, status, jhr) {
            setTimeout(() => {
                if (!$.ajaxQueue().length) {
                    $('html').removeClass('ajax-queue');
                    $(document).triggerHandler(Fotobook.events.AJAX_QUEUE_FINISHED);
                }
            }, 0);
        },

        handleRedirect(xhr) {
            const url = xhr && xhr.getResponseHeader('X-Redirect');
            if (url) {
                window.location = url;
            }
            return url;
        },

        submitForm(url, form) {
            self.post(url, {
                data: {
                    params: form.serialize(),
                },
            });
        },

        addCsrfHeader(event, jqxhr, settings) {
            if (['GET', 'HEAD', 'OPTIONS'].indexOf(settings.type) === -1) {
                jqxhr.setRequestHeader('X-CSRF-Token', Fotobook.store.state.csrf.token);
            }
        },
    };

    $(document).on('ajaxSend', self.addCsrfHeader);

})();
